import { useEffect, useState } from 'react';
import { getApiBaseUrl } from '../../utils/apiConfig';

let cached = undefined;
let inflight = null;
let activeNow = false;

function fetchCutoverActive() {
  if (cached !== undefined) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = fetch(`${getApiBaseUrl()}/api/pg-native/cutover/summary`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
  })
    .then((res) => res.json())
    .then((j) => {
      cached = j.phase === 'transition' || j.phase === 'drained';
      activeNow = cached;
      return cached;
    })
    .catch(() => {
      cached = false;
      return false;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

/** Rótulo do cadastro: Serviços no cutover; Defeito no ERP. */
export function defeitoTerm(active = activeNow) {
  return active ? 'Serviços' : 'Defeito';
}

/** true quando o cliente já passou pelo cutover (OS nativas no Postgres). */
export default function useCutoverActive() {
  const [active, setActive] = useState(activeNow);

  useEffect(() => {
    let alive = true;
    fetchCutoverActive().then((value) => {
      if (alive) setActive(value);
    });
    return () => {
      alive = false;
    };
  }, []);

  return active;
}
